import React, { useEffect } from "react";
import MyRouter from "routers/index";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "provider/AuthProvider";

function App() {
	return (
		<HelmetProvider>
			<Helmet>
				<title>PLANNING | FULFILLER</title>
				<meta name="description" content="" />
			</Helmet>

			{/* MAIN APP */}
			<div className="bg-white text-base dark:bg-slate-900 text-slate-900 dark:text-slate-200">
				<BrowserRouter>
					<AuthProvider>
						<MyRouter />
					</AuthProvider>
				</BrowserRouter>
			</div>
		</HelmetProvider>
	);
}

export default App;
